import React from 'react';
import '../template-file-css/document-file-template.css';



export const LaGeneral_Asam = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LaGeneral_Asam' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'><h2>Demographic information</h2></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Okay to leave voicemail?</span>
                            <input type='radio' id='rbLeave_Yes' name='rbLeave' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbLeave_No' name='rbLeave' className='add-only' value='No' /> No
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Age</span>
                            <input type='text' id='txtAge' name='txtAge' className='add-only' />
                        </td>
                        <td className='w-350'>
                            <span className='eleHeader'>Preferred Language</span>
                            <input type='text' id='txtPreferredLanguage' name='txtPreferredLanguage' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Insurance Type</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNone' name='cbNone' className='add-only' value='1' />
                            None
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedicaid' name='cbMedicaid' className='add-only' value='1' />
                            Medicaid
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMedicare' name='cbMedicare' className='add-only' value='1' />
                            Medicare (Plan): &nbsp;
                            <input type='text' id='txtMedicare' name='txtMedicare' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbMCO' name='cbMCO' className='add-only' value='1' />
                            MCO (Plan): &nbsp;
                            <input type='text' id='txtMCO' name='txtMCO' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbPrivate' name='cbPrivate' className='add-only' value='1' />
                            Private (Plan):&nbsp;
                            <input type='text' id='txtPrivate' name='txtPrivate' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOther' name='cbOther' className='add-only' value='1' />
                            Other (Plan): &nbsp;
                            <input type='text' id='txtOther' name='txtOther' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Living Arrangement</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHomeless' name='cbHomeless' className='add-only' value='1' />
                            Homeless
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIndependentLiving' name='cbIndependentLiving' className='add-only' value='1' />
                            Independent Living
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbOtherSpecify' name='cbOtherSpecify' className='add-only' value='1' />
                            Other (specify): &nbsp;
                            <input type='text' id='txtOtherSpecify' name='txtOtherSpecify' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Referred by (specify)</span>
                    <textarea id='txtReferredBy' name='txtReferredBy' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Explanation of why patient is currently seeking treatment</span>
                    <span className='small'>Current symptoms, functional impairment, severity, duration of symptoms (e.g., unable to work/school, relationship/housing problems)</span>
                    <textarea id='txtExplanationSeekingTreatment' name='txtExplanationSeekingTreatment' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Dimension 1: Substance Use, Acute Intoxication and/or Withdrawal Potential</h2></p>

                <p className='w-750'><h3>1.Substance use history</h3></p>

                <table>
                    <tr>
                        <td className='w-125'><span className='eleHeader'>Alcohol and/or Drug Types</span></td>
                        <td className='w-100'><span className='eleHeader'>Recently Used?<span className='small'>(Past 6 Months)</span></span></td>
                        <td className='w-70'><span className='eleHeader'>Prior Use?<span className='small'>(Lifetime)</span></span></td>
                        <td className='w-110'><span className='eleHeader'>Route<span className='small'>(Inject, Smoke, Snort)</span></span></td>
                        <td className='w-120'><span className='eleHeader'>Frequency<span className='small'>(Daily, Weekly, Monthly)</span></span></td>
                        <td className='w-75'><span className='eleHeader'>Duration<span className='small'>(Length of Use)</span></span></td>
                        <td className='w-150'><span className='eleHeader'>Date of Last Use</span></td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>Amphetamines
                            <span className='small'>(Meth, Ice, Crank)</span>
                        </td>
                        <td className='w-100'>
                            <center><input type='checkbox' id='cbAmphetamines_RecentlyUsed' name='cbAmphetamines_RecentlyUsed' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cbAmphetamines_PriorUse' name='cbAmphetamines_PriorUse' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtAmphetamines_Route' name='txtAmphetamines_Route' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtAmphetamines_Frequency' name='txtAmphetamines_Frequency' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtAmphetamines_Duration' name='txtAmphetamines_Duration' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtAmphetamines_Date' name='txtAmphetamines_Date' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>Alcohol</td>
                        <td className='w-100'>
                            <center><input type='checkbox' id='cbAlcohol_RecentlyUsed' name='cbAlcohol_RecentlyUsed' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cbAlcohol_PriorUse' name='cbAlcohol_PriorUse' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtAlcohal_Route' name='txtAlcohal_Route' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtAlcohal_Frequency' name='txtAlcohal_Frequency' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtAlcohal_Duration' name='txtAlcohal_Duration' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtAlcohal_Date' name='txtAlcohal_Date' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>Cocaine/Crack</td>
                        <td className='w-100'>
                            <center><input type='checkbox' id='cbCocaine_RecentlyUsed' name='cbCocaine_RecentlyUsed' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cbCocaine_PriorUse' name='cbCocaine_PriorUse' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtCocaine_Route' name='txtCocaine_Route' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtCocaine_Frequency' name='txtCocaine_Frequency' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtCocaine_Duration' name='txtCocaine_Duration' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtCocaine_Date' name='txtCocaine_Date' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>Heroin</td>
                        <td className='w-100'>
                            <center><input type='checkbox' id='cbHeroin_RecentlyUsed' name='cbHeroin_RecentlyUsed' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cbHeroin_PriorUse' name='cbHeroin_PriorUse' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtHeroin_Route' name='txtHeroin_Route' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtHeroin_Frequency' name='txtHeroin_Frequency' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtHeroin_Duration' name='txtHeroin_Duration' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtHeroin_Date' name='txtHeroin_Date' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>Marijuana</td>
                        <td className='w-100'>
                            <center><input type='checkbox' id='cbMarijuana_RecentlyUsed' name='cbMarijuana_RecentlyUsed' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cbMarijuana_PriorUse' name='cbMarijuana_PriorUse' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtMarijuana_Route' name='txtMarijuana_Route' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtMarijuana_Frequency' name='txtMarijuana_Frequency' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtMarijuana_Duration' name='txtMarijuana_Duration' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtMarijuana_Date' name='txtMarijuana_Date' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>Opioid Pain Medications
                            <span className='small'>Misuse or without prescription</span>
                        </td>
                        <td className='w-100'>
                            <center><input type='checkbox' id='cbOpioid_RecentlyUsed' name='cbOpioid_RecentlyUsed' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cbOpioid_PriorUse' name='cbOpioid_PriorUse' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtOpioid_Route' name='txtOpioid_Route' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtOpioid_Frequency' name='txtOpioid_Frequency' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtOpioid_Duration' name='txtOpioid_Duration' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtOpioid_Date' name='txtOpioid_Date' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>Sedatives
                            <span className='small'>(Benzos, Sleeping Pills)</span>
                            <span className='small'>Misuse or without prescription</span>
                        </td>
                        <td className='w-100'>
                            <center><input type='checkbox' id='cbSedatives_RecentlyUsed' name='cbSedatives_RecentlyUsed' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cbSedatives_PriorUse' name='cbSedatives_PriorUse' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtSedatives_Route' name='txtSedatives_Route' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtSedatives_Frequency' name='txtSedatives_Frequency' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtSedatives_Duration' name='txtSedatives_Duration' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtSedatives_Date' name='txtSedatives_Date' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>Hallucinogens</td>
                        <td className='w-100'>
                            <center><input type='checkbox' id='cbHallucinogens_RecentlyUsed' name='cbHallucinogens_RecentlyUsed' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cbHallucinogens_PriorUse' name='cbHallucinogens_PriorUse' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtHallucinogens_Route' name='txtHallucinogens_Route' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtHallucinogens_Frequency' name='txtHallucinogens_Frequency' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtHallucinogens_Duration' name='txtHallucinogens_Duration' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtHallucinogens_Date' name='txtHallucinogens_Date' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>Inhalants</td>
                        <td className='w-100'>
                            <center><input type='checkbox' id='cbInhalants_RecentlyUsed' name='cbInhalants_RecentlyUsed' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cbInhalants_PriorUse' name='cbInhalants_PriorUse' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtInhalants_Route' name='txtInhalants_Route' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtInhalants_Frequency' name='txtInhalants_Frequency' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtInhalants_Duration' name='txtInhalants_Duration' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtInhalants_Date' name='txtInhalants_Date' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>Over-the-Counter Medications
                            <span className='small'>(Cough Syrup, Diet Aids)</span>
                        </td>
                        <td className='w-100'>
                            <center><input type='checkbox' id='cbMedications_RecentlyUsed' name='cbMedications_RecentlyUsed' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cbMedications_PriorUse' name='cbMedications_PriorUse' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtMedications_Route' name='txtMedications_Route' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtMedications_Frequency' name='txtMedications_Frequency' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtMedications_Duration' name='txtMedications_Duration' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtMedications_Date' name='txtMedications_Date' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-125'>Nicotine</td>
                        <td className='w-100'>
                            <center><input type='checkbox' id='cbNicotine_RecentlyUsed' name='cbNicotine_RecentlyUsed' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cbNicotine_PriorUse' name='cbNicotine_PriorUse' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtNicotine_Route' name='txtNicotine_Route' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtNicotine_Frequency' name='txtNicotine_Frequency' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtNicotine_Duration' name='txtNicotine_Duration' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtNicotine_Date' name='txtNicotine_Date' className='add-only' />
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-750'>Other:</td>
                    </tr>
                    <tr>
                        <td className='w-125'>
                            <input type='text' id='txt_Other' name='txt_Other' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <center><input type='checkbox' id='cbOther_RecentlyUsed' name='cbOther_RecentlyUsed' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-70'>
                            <center><input type='checkbox' id='cbOther_PriorUse' name='cbOther_PriorUse' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-110'>
                            <input type='text' id='txtOther_Route' name='txtOther_Route' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtOther_Frequency' name='txtOther_Frequency' className='add-only' />
                        </td>
                        <td className='w-75'>
                            <input type='text' id='txtOther_Duration' name='txtOther_Duration' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='date' id='txtOther_Date' name='txtOther_Date' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Information</span>
                    <textarea id='txtAdditionalInformation_1' name='txtAdditionalInformation_1' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>2. Do you find yourself using more alcohol and/or drugs than you intend to?</span>
                    <input type='radio' id='rbAlcohalDrugs_Yes' name='rbAlcohalDrugs' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAlcohalDrugs_No' name='rbAlcohalDrugs' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <span className='small'>Please describe:</span>
                    <textarea id='txtPleaseDescribe_1' name='txtPleaseDescribe_1' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>3. Do you get physically ill when you stop using alcohol and/or drugs?</span>
                    <input type='radio' id='rbPhysically_Yes' name='rbPhysically' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbPhysically_No' name='rbPhysically' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe:</span>
                    <textarea id='txtPleaseDescribe_2' name='txtPleaseDescribe_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>4. Are you currently experiencing withdrawal symptoms, such as tremors, excessive sweating, rapid heart rate,blackouts, anxiety, vomiting, etc.?</span>
                    <input type='radio' id='rbWithdrawalSymptoms_Yes' name='rbWithdrawalSymptoms' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbWithdrawalSymptoms_No' name='rbWithdrawalSymptoms' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe specific symptoms and consider immediate referral for medical evaluation:</span>
                    <textarea id='txtPleaseDescribe_3' name='txtPleaseDescribe_3' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>5. Do you have a history of serious withdrawal, seizures, or life-threatening symptoms during withdrawal?</span>
                    <input type='radio' id='rbSeriousWithdrawal_Yes' name='rbSeriousWithdrawal' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbSeriousWithdrawal_No' name='rbSeriousWithdrawal' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe and specify withdrawal substance(s):</span>
                    <textarea id='txtPleaseDescribe_4' name='txtPleaseDescribe_4' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>6. Do you find yourself using more alcohol and/or drugs in order to get the same high?</span>
                    <input type='radio' id='rbFindYourself_Yes' name='rbFindYourself' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbFindYourself_No' name='rbFindYourself' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe:</span>
                    <textarea id='txtPleaseDescribe_5' name='txtPleaseDescribe_5' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>7. Has your alcohol and/or drug use changed recently (increase/ decreased, changed route of use)?</span>
                    <input type='radio' id='rbIncreaseDecrease_Yes' name='rbIncreaseDecrease' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbIncreaseDecrease_No' name='rbIncreaseDecrease' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe:</span>
                    <textarea id='txtPleaseDescribe_6' name='txtPleaseDescribe_6' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>8. Please describe family history of alcohol and/or drug use</span>
                    <input type='radio' id='rbFamilyHistory_Yes' name='rbFamilyHistory' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbFamilyHistory_No' name='rbFamilyHistory' className='add-only' value='No' /> No
                    <textarea id='txtPleaseDescribe_7' name='txtPleaseDescribe_7' className='add-only'></textarea>
                </p>
                <p className='w-750'><h3>Please circle one of the following levels of severity</h3></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Severity Rating- Dimension 1 (Substance Use, Acute Intoxication and/or Withdrawal Potential)</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-150'>0 &nbsp;
                            <input type='radio' id='rb_None' name='rbSeverityRating' className='add-only' value='None' /> None
                        </td>
                        <td className='w-150'>1 &nbsp;
                            <input type='radio' id='rb_Mild' name='rbSeverityRating' className='add-only' value='Mild' /> Mild
                        </td>
                        <td className='w-150'>2 &nbsp;
                            <input type='radio' id='rb_Moderate' name='rbSeverityRating' className='add-only' value='Moderate' /> Moderate
                        </td>
                        <td className='w-150'>3 &nbsp;
                            <input type='radio' id='rb_Severe' name='rbSeverityRating' className='add-only' value='Severe' /> Severe
                        </td>
                        <td className='w-150'>4 &nbsp;
                            <input type='radio' id='rb_VerySevere' name='rbSeverityRating' className='add-only' value='VerySevere' /> Very Severe
                        </td>
                    </tr>

                    <tr>
                        <td className='w-150'>
                            <span className='small'>No signs of withdrawal/intoxication present</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Mild/moderate intoxication, interferers with daily functioning. Minimal risk of severe withdrawal. No danger to self/others.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>May have severe intoxication but responds to support. Moderate risk of severe withdrawal. No danger to self/others.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Severe intoxication with imminent risk of danger to self/others. Risk of severe manageable withdrawal.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Incapacitated. Severe signs and symptoms. Presents danger, i.e. seizures. Continued substance use poses an imminent threat to life.</span>
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Information</span>
                    <textarea id='txtAdditionalInformation_2' name='txtAdditionalInformation_2' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Dimension 2: Biomedical Conditions and Complications</h2></p>
                <p className='w-750'><h3>9. Please list known medical provider(s)</h3></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Physician Name</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Specialty</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Contact Information</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPhysicianName_1' name='txtPhysicianName_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSpecialty_1' name='txtSpecialty_1' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtContactInformation_1' name='txtContactInformation_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPhysicianName_2' name='txtPhysicianName_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSpecialty_2' name='txtSpecialty_2' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtContactInformation_2' name='txtContactInformation_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPhysicianName_3' name='txtPhysicianName_3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSpecialty_3' name='txtSpecialty_3' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtContactInformation_3' name='txtContactInformation_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPhysicianName_4' name='txtPhysicianName_4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSpecialty_4' name='txtSpecialty_4' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtContactInformation_4' name='txtContactInformation_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPhysicianName_5' name='txtPhysicianName_5' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtSpecialty_5' name='txtSpecialty_5' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtContactInformation_5' name='txtContactInformation_5' className='add-only' />
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>10. Do you have any of the following medical conditions</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHeartProblems' name='cbHeartProblems' className='add-only' value='1' />
                            Heart Problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSeizureNeurological' name='cbSeizureNeurological' className='add-only' value='1' />
                            Seizure/Neurological
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMuscleJointProblems' name='cbMuscleJointProblems' className='add-only' value='1' />
                            Muscle/Joint Problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDiabetes' name='cbDiabetes' className='add-only' value='1' />
                            Diabetes
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHighBloodPressure' name='cbHighBloodPressure' className='add-only' value='1' />
                            High Blood Pressure
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbThyroidProblems' name='cbThyroidProblems' className='add-only' value='1' />
                            Thyroid Problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbVisionProblems' name='cbVisionProblems' className='add-only' value='1' />
                            Vision Problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSleepProblems' name='cbSleepProblems' className='add-only' value='1' />
                            Sleep Problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHighCholesterol' name='cbHighCholesterol' className='add-only' value='1' />
                            Thyroid Problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbKidneyProblems' name='cbKidneyProblems' className='add-only' value='1' />
                            Kidney Problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHearingProblems' name='cbHearingProblems' className='add-only' value='1' />
                            Hearing Problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbChroniPain' name='cbChroniPain' className='add-only' value='1' />
                            Chronic Pain
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBloodDisorder' name='cbBloodDisorder' className='add-only' value='1' />
                            Blood Disorder
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLiverProblems' name='cbLiverProblems' className='add-only' value='1' />
                            Liver Problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDentalProblems' name='cbDentalProblems' className='add-only' value='1' />
                            Dental Problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPregnant' name='cbPregnant' className='add-only' value='1' />
                            Pregnant
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbStomachIntestinalProblems' name='cbStomachIntestinalProblems' className='add-only' value='1' />
                            Stomach/Intestinal Problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAsthmaLungProblems' name='cbAsthmaLungProblems' className='add-only' value='1' />
                            Asthma/Lung Problems
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSexuallyTransmitted' name='cbSexuallyTransmitted' className='add-only' value='1' />
                            Sexually Transmitted Disease(s): &nbsp;
                            <input type='text' id='txtSexuallyTransmitted' name='txtSexuallyTransmitted' className='add-only w-300 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbCancerSpecifyType' name='cbCancerSpecifyType' className='add-only' value='1' />
                            Cancer (specify type[s]): &nbsp;
                            <input type='text' id='txtCancerSpecifyType' name='txtCancerSpecifyType' className='add-only w-300 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbInfection' name='cbInfection' className='add-only' value='1' />
                            Infection(s): &nbsp;
                            <input type='text' id='txtInfection' name='txtInfection' className='add-only w-300 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAllergies' name='cbAllergies' className='add-only' value='1' />
                            Allergies: &nbsp;
                            <input type='text' id='txtAllergies' name='txtAllergies' className='add-only w-300 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbMedical_Other' name='cbMedical_Other' className='add-only' value='1' />
                            Other: &nbsp;
                            <input type='text' id='txtMedical_Other' name='txtMedical_Other' className='add-only w-300 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>11. Do any of these conditions significantly interfere with your life?</span>
                    <input type='radio' id='rbConditionsSignificantly_Yes' name='rbConditionsSignificantly' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbConditionsSignificantly_No' name='rbConditionsSignificantly' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <span className='small'>Please describe</span>
                    <textarea id='txtPleaseDescribe_8' name='txtPleaseDescribe_8' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>12. Provide additional comments on medical conditions, prior hospitalizations (include dates and reasons)</span>
                    <textarea id='txtMedicalConditions' name='txtMedicalConditions' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>13. Question to be answered by interviewer: Does the patient report medical symptoms that would be considered life-threatening or require immediate medical attention?</span>
                    <input type='radio' id='rbMedicalSymptoms_Yes' name='rbMedicalSymptoms' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMedicalSymptoms_No' name='rbMedicalSymptoms' className='add-only' value='No' /> No
                </p>

                <p className='w-750'>
                    <b>If yes, consider immediate referral to emergency room or call 911</b>
                </p>

                <p className='w-750'><h3>14. List all current medication(s) for medical condition(s):</h3></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medication</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Dose / Frequency</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Reason</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Effectiveness/Side Effects</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMedication_1' name='txtMedication_1' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDose_1' name='txtDose_1' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtReason_1' name='txtReason_1' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtEffectiveness_1' name='txtEffectiveness_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMedication_2' name='txtMedication_2' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDose_2' name='txtDose_2' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtReason_2' name='txtReason_2' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtEffectiveness_2' name='txtEffectiveness_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMedication_3' name='txtMedication_3' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDose_3' name='txtDose_3' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtReason_3' name='txtReason_3' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtEffectiveness_3' name='txtEffectiveness_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMedication_4' name='txtMedication_4' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDose_4' name='txtDose_4' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtReason_4' name='txtReason_4' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtEffectiveness_4' name='txtEffectiveness_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtMedication_5' name='txtMedication_5' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtDose_5' name='txtDose_5' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtReason_5' name='txtReason_5' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtEffectiveness_5' name='txtEffectiveness_5' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Please circle one of the following levels of severity</h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Severity Rating- Dimension 2 (Biomedical Conditions and Complications)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>0 &nbsp;
                            <input type='radio' id='rb_None_2' name='rbSeverityRating_2' className='add-only' value='None' /> None
                        </td>
                        <td className='w-150'>1 &nbsp;
                            <input type='radio' id='rb_Mild_2' name='rbSeverityRating_2' className='add-only' value='Mild' /> Mild
                        </td>
                        <td className='w-150'>2 &nbsp;
                            <input type='radio' id='rb_Moderate_2' name='rbSeverityRating_2' className='add-only' value='Moderate' /> Moderate
                        </td>
                        <td className='w-150'>3 &nbsp;
                            <input type='radio' id='rb_Severe_2' name='rbSeverityRating_2' className='add-only' value='Severe' /> Severe
                        </td>
                        <td className='w-150'>4 &nbsp;
                            <input type='radio' id='rb_VerySevere_2' name='rbSeverityRating_2' className='add-only' value='VerySevere' /> Very Severe
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='small'>Fully functional/ able to cope with discomfort or pain.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Mild to moderate symptoms interfering with daily functioning. Adequate ability to cope with physical discomfort.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Some difficulty tolerating physical problems. Acute, nonlife threatening problems present, or serious biomedical problems are neglected.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Serious medical problems neglected during outpatient or intensive outpatient treatment. Severe medical problems present but stable. Poor ability to cope with physical problems.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Incapacitated with severe medical problems.</span>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comment</span>
                    <textarea id='txtAdditionalComment_3' name='txtAdditionalComment_3' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Dimension 3: Emotional, Behavioral, or Cognitive Conditions and Complications</h2></p>
                <p className='w-750'><h3>15. Do you consider any of the following behaviors or symptoms to be problematic?</h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Mood</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDepressionSadness' name='cbDepressionSadness' className='add-only' value='1' />
                            Depression/sadness
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLossPleasureInterest' name='cbLossPleasureInterest' className='add-only' value='1' />
                            Loss of Pleasure/Interest
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHopelessness' name='cbHopelessness' className='add-only' value='1' />
                            Hopelessness
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbIrritability' name='cbIrritability' className='add-only' value='1' />
                            Irritability/Anger
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbImpulsivity' name='cbImpulsivity' className='add-only' value='1' />
                            Impulsivity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPressured' name='cbPressured' className='add-only' value='1' />
                            Pressured Speech
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGrandiosity' name='cbGrandiosity' className='add-only' value='1' />
                            Grandiosity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRacingThoughts' name='cbRacingThoughts' className='add-only' value='1' />
                            Racing Thoughts
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Anxiety</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAnxiety' name='cbAnxiety' className='add-only' value='1' />
                            Anxiety/Excessive Worry
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbObsessive' name='cbObsessive' className='add-only' value='1' />
                            Obsessive Thoughts
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbCompulsive' name='cbCompulsive' className='add-only' value='1' />
                            Compulsive Behaviors
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFlashbacks' name='cbFlashbacks' className='add-only' value='1' />
                            Flashbacks
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Psychosis</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbParanoia' name='cbParanoia' className='add-only' value='1' />
                            Paranoia
                        </td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbDelusions' name='cbDelusions' className='add-only' value='1' />
                            Delusions: &nbsp;
                            <input type='text' id='txtDelusions' name='txtDelusions' className='add-only w-200 custom-add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbHallucinations' name='cbHallucinations' className='add-only' value='1' />
                            Hallucinations: &nbsp;
                            <input type='text' id='txtHallucinations' name='txtHallucinations' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Other</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSleepProblem' name='cbSleepProblem' className='add-only' value='1' />
                            Sleep Problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMemoryConcentration' name='cbMemoryConcentration' className='add-only' value='1' />
                            Memory/Concentration
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbGambling' name='cbGambling' className='add-only' value='1' />
                            Gambling
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbRiskySexBehaviors' name='cbRiskySexBehaviors' className='add-only' value='1' />
                            Risky Sex Behaviors
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <input type='checkbox' id='cbSuicidalThoughts' name='cbSuicidalThoughts' className='add-only' value='1' />
                    Suicidal Thoughts: please describe
                    <textarea id='txtSuicidalThoughts' name='txtSuicidalThoughts' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbThoughtsOfHarmingOthers' name='cbThoughtsOfHarmingOthers' className='add-only' value='1' />
                    Thoughts of Harming Others: please describe
                    <textarea id='txtThoughtsOfHarmingOthers' name='txtThoughtsOfHarmingOthers' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbAbuse' name='cbAbuse' className='add-only' value='1' />
                    Abuse (physical, emotional, sexual): please describe
                    <textarea id='txtAbuse' name='txtAbuse' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbTraumatic' name='cbTraumatic' className='add-only' value='1' />
                    Traumatic Event(s): please describe
                    <textarea id='txtTraumatic' name='txtTraumatic' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <input type='checkbox' id='cbOther_2' name='cbOther_2' className='add-only' value='1' />
                    Other:
                    <textarea id='txtOther_2' name='txtOther_2' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>16. Have you ever been diagnosed with a mental illness?</span>
                    <input type='radio' id='rbMentalIllness_Yes' name='rbMentalIllness' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMentalIllness_No' name='rbMentalIllness' className='add-only' value='No' /> No &nbsp;
                    <input type='radio' id='rbMentalIllness_NotSure' name='rbMentalIllness' className='add-only' value='Not Sure' /> Not Sure
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe (e.g., diagnosis, medications?)</span>
                    <textarea id='txtPleaseDescribe_9' name='txtPleaseDescribe_9' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>17. Are you currently or have you previously received treatment for psychiatric or emotional problems?</span>
                    <input type='radio' id='rbEmotionalProblem_Yes' name='rbEmotionalProblem' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbEmotionalProblem_No' name='rbEmotionalProblem' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe (e.g., treatment setting, hospitalizations, duration of treatment):</span>
                    <textarea id='txtPleaseDescribe_10' name='txtPleaseDescribe_10' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>18. Do you ever see or hear things that other people say they do not see or hear?</span>
                    <input type='radio' id='rbDoNotSee_Yes' name='rbDoNotSee' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbDoNotSee_No' name='rbDoNotSee' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe:</span>
                    <textarea id='txtPleaseDescribe_11' name='txtPleaseDescribe_11' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>19. Question to be answered by interviewer: Based on previous questions, is further assessment of mental healthneeded?</span>
                    <input type='radio' id='rbMentalHealth_Yes' name='rbMentalHealth' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbMentalHealth_No' name='rbMentalHealth' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe:</span>
                    <textarea id='txtPleaseDescribe_12' name='txtPleaseDescribe_12' className='add-only'></textarea>
                </p>
                <p className='w-750'><h3>20. List all current medication(s) for psychiatric condition(s)</h3></p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Medication</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Dose / Frequency</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Reason</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Effectiveness/Side Effects</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPsychiatricMedication_1' name='txtPsychiatricMedication_1' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtPsychiatricDose_1' name='txtPsychiatricDose_1' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtPsychiatricReason_1' name='txtPsychiatricReason_1' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtPsychiatricEffectiveness_1' name='txtPsychiatricEffectiveness_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPsychiatricMedication_2' name='txtPsychiatricMedication_2' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtPsychiatricDose_2' name='txtPsychiatricDose_2' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtPsychiatricReason_2' name='txtPsychiatricReason_2' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtPsychiatricEffectiveness_2' name='txtPsychiatricEffectiveness_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPsychiatricMedication_3' name='txtPsychiatricMedication_3' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtPsychiatricDose_3' name='txtPsychiatricDose_3' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtPsychiatricReason_3' name='txtPsychiatricReason_3' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtPsychiatricEffectiveness_3' name='txtPsychiatricEffectiveness_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPsychiatricMedication_4' name='txtPsychiatricMedication_4' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtPsychiatricDose_4' name='txtPsychiatricDose_4' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtPsychiatricReason_4' name='txtPsychiatricReason_4' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtPsychiatricEffectiveness_4' name='txtPsychiatricEffectiveness_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtPsychiatricMedication_5' name='txtPsychiatricMedication_5' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id='txtPsychiatricDose_5' name='txtPsychiatricDose_5' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtPsychiatricReason_5' name='txtPsychiatricReason_5' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id='txtPsychiatricEffectiveness_5' name='txtPsychiatricEffectiveness_5' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>21. Please list mental health provider(s)</h3></p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Provider Name</span></td>
                        <td className='w-375'><span className='eleHeader'>Contact Information</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderName_1' name='txtProviderName_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtContact_1' name='txtContact_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderName_2' name='txtProviderName_2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtContact_2' name='txtContact_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderName_3' name='txtProviderName_3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtContact_3' name='txtContact_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtProviderName_4' name='txtProviderName_4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtContact_4' name='txtContact_4' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Please circle one of the following levels of severity</h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Severity Rating- Dimension 3 (Emotional, Behavioral, or Cognitive Conditions and Complications)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>0 &nbsp;
                            <input type='radio' id='rb_None_3' name='rbSeverityRating_3' className='add-only' value='None' /> None
                        </td>
                        <td className='w-150'>1 &nbsp;
                            <input type='radio' id='rb_Mild_3' name='rbSeverityRating_3' className='add-only' value='Mild' /> Mild
                        </td>
                        <td className='w-150'>2 &nbsp;
                            <input type='radio' id='rb_Moderate_3' name='rbSeverityRating_3' className='add-only' value='Moderate' /> Moderate
                        </td>
                        <td className='w-150'>3 &nbsp;
                            <input type='radio' id='rb_Severe_3' name='rbSeverityRating_3' className='add-only' value='Severe' /> Severe
                        </td>
                        <td className='w-150'>4 &nbsp;
                            <input type='radio' id='rb_VerySevere_3' name='rbSeverityRating_3' className='add-only' value='VerySevere' /> Very Severe
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='small'>Good impulse control and coping skills. No dangerousness, good social functioning and self-care, no interference with recovery.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Suspect diagnosis of EBC, requires intervention, but does not interfere with recovery. Some relationship impairment.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Persistent EBC. Symptoms distract from recovery, but no immediate threat to self/others. Does not prevent independent functioning.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Severe EBC, but does not require acute level of care. Impulse to harm self or others, but not dangerous in a 24-hr setting.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Severe EBC. Requires acute level of care. Exhibits severe and acute life-threatening symptoms (posing imminent danger to self/others).</span>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comment</span>
                    <textarea id='txtAdditionalComment_4' name='txtAdditionalComment_4' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Dimension 4: Readiness to Change</h2></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>22. Is your alcohol and/or drug use affecting any of the following?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbWork' name='cbWork' className='add-only' value='1' />
                            Work
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMentalHealth' name='cbMentalHealth' className='add-only' value='1' />
                            Mental Health
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPhysicalHealth' name='cbPhysicalHealth' className='add-only' value='1' />
                            Physical Health
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFinances' name='cbFinances' className='add-only' value='1' />
                            Finances
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSchool' name='cbSchool' className='add-only' value='1' />
                            School
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRelationships' name='cbRelationships' className='add-only' value='1' />
                            Relationships
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSexualActivity' name='cbSexualActivity' className='add-only' value='1' />
                            Sexual Activity
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbLegalMatters' name='cbLegalMatters' className='add-only' value='1' />
                            Legal Matters
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHandlingEverydayTasks' name='cbHandlingEverydayTasks' className='add-only' value='1' />
                            Handling Everyday Tasks
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSelfEsteem' name='cbSelfEsteem' className='add-only' value='1' />
                            Self-esteem
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbHygiene' name='cbHygiene' className='add-only' value='1' />
                            Hygiene
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRecreationalActivities' name='cbRecreationalActivities' className='add-only' value='1' />
                            Recreational Activities
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAlcohal_Other' name='cbAlcohal_Other' className='add-only' value='1' />
                            Other: &nbsp;
                            <input type='text' id='txtAlcohal_Other' name='txtAlcohal_Other' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>23. Do you continue to use alcohol or drugs despite having it affect the areas listed above?</span>
                    <input type='radio' id='rbAlcohalOrDrugs_Yes' name='rbAlcohalOrDrugs' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAlcohalOrDrugs_No' name='rbAlcohalOrDrugs' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe:</span>
                    <textarea id='txtPleaseDescribe_13' name='txtPleaseDescribe_13' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>24. Have you received help for alcohol and/or drug problems in the past?</span>
                    <input type='radio' id='rbAlcohalOrDrugsPast_Yes' name='rbAlcohalOrDrugsPast' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAlcohalOrDrugsPast_No' name='rbAlcohalOrDrugsPast' className='add-only' value='No' /> No
                </p>
                <table>
                    <tr>
                        <td className='w-750'>Please list treatment provider(s)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Provider Name</span></td>
                        <td className='w-375'><span className='eleHeader'>Contact Information</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtTreatmentProviderName_1' name='txtTreatmentProviderName_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtTreatmentContact_1' name='txtTreatmentContact_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtTreatmentProviderName_2' name='txtTreatmentProviderName_2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtTreatmentContact_2' name='txtTreatmentContact_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtTreatmentProviderName_3' name='txtTreatmentProviderName_3' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtTreatmentContact_3' name='txtTreatmentContact_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtTreatmentProviderName_4' name='txtTreatmentProviderName_4' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtTreatmentContact_4' name='txtTreatmentContact_4' className='add-only' />
                        </td>
                    </tr>
                </table>


                <p className='w-750'>
                    <span className='eleHeader'>25. What would help to support your recovery?</span>
                    <textarea id='txtSupportYourRecovery' name='txtSupportYourRecovery' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>26. What are potential barriers to your recovery (e.g., financial, transportation, relationships, etc.)?</span>
                    <textarea id='txtBarriersYourRecovery' name='txtBarriersYourRecovery' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>27. How important is it for you to receive treatment for</h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Alcohal Problems</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAlcohol_NotAtAll' name='cbAlcohol_NotAtAll' className='add-only' value='1' />
                            Not at all
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAlcohol_Slightly' name='cbAlcohol_Slightly' className='add-only' value='1' />
                            Slightly
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAlcohol_Moderately' name='cbAlcohol_Moderately' className='add-only' value='1' />
                            Moderately
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAlcohol_Considerably' name='cbAlcohol_Considerably' className='add-only' value='1' />
                            Considerably
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAlcohol_Extremely' name='cbAlcohol_Extremely' className='add-only' value='1' />
                            Extremely
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Drug Problems</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDrug_NotAtAll' name='cbDrug_NotAtAll' className='add-only' value='1' />
                            Not at all
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDrug_Slightly' name='cbDrug_Slightly' className='add-only' value='1' />
                            Slightly
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDrug_Moderately' name='cbDrug_Moderately' className='add-only' value='1' />
                            Moderately
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDrug_Considerably' name='cbDrug_Considerably' className='add-only' value='1' />
                            Considerably
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDrug_Extremely' name='cbDrug_Extremely' className='add-only' value='1' />
                            Extremely
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='small'>Please describe:</span>
                    <textarea id='txtPleaseDescribe_14' name='txtPleaseDescribe_14' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>Please circle one of the following levels of severity</h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Severity Rating- Dimension 4 (Readiness to Change)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>0 &nbsp;
                            <input type='radio' id='rb_None_4' name='rbSeverityRating_4' className='add-only' value='None' /> None
                        </td>
                        <td className='w-150'>1 &nbsp;
                            <input type='radio' id='rb_Mild_4' name='rbSeverityRating_4' className='add-only' value='Mild' /> Mild
                        </td>
                        <td className='w-150'>2 &nbsp;
                            <input type='radio' id='rb_Moderate_4' name='rbSeverityRating_4' className='add-only' value='Moderate' /> Moderate
                        </td>
                        <td className='w-150'>3 &nbsp;
                            <input type='radio' id='rb_Severe_4' name='rbSeverityRating_4' className='add-only' value='Severe' /> Severe
                        </td>
                        <td className='w-150'>4 &nbsp;
                            <input type='radio' id='rb_VerySevere_4' name='rbSeverityRating_4' className='add-only' value='VerySevere' /> Very Severe
                        </td>
                    </tr>

                    <tr>
                        <td className='w-150'>
                            <span className='small'>Willing to engage in treatment.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Willing to enter treatment, but ambivalent to the need to change.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Reluctant to agree to treatment. Low commitment to change substance use. Passive engagement in treatment.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Unaware of need to change. Unwilling or partially able to follow through with recommendations for treatment.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Not willing to change. Unwilling/unable to follow through with treatment recommendations.</span>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments</span>
                    <textarea id='txtAdditionalComments' name='txtAdditionalComments' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Dimension 5: Relapse, Continued Use, or Continued Problem Potential</h2><br /></p>
                <p className='w-750'><h3>28. In the last 30 days, how often have you experienced cravings, withdrawal symptoms, disturbing effects of use?</h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Alcohal</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAlcohol_None' name='cbAlcohol_None' className='add-only' value='1' />
                            None
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAlcohol_Occasionally' name='cbAlcohol_Occasionally' className='add-only' value='1' />
                            Occasionally
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAlcohol_Frequently' name='cbAlcohol_Frequently' className='add-only' value='1' />
                            Frequently
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbAlcohol_Constantly' name='cbAlcohol_Constantly' className='add-only' value='1' />
                            Constantly
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Drug</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDrug_None' name='cbDrug_None' className='add-only' value='1' />
                            None
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDrug_Occasionally' name='v' className='add-only' value='1' />
                            Occasionally
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDrug_Frequently' name='cbDrug_Frequently' className='add-only' value='1' />
                            Frequently
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDrug_Constantly' name='cbDrug_Constantly' className='add-only' value='1' />
                            Constantly
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='small'>Please describe:</span>
                    <textarea id='txtPleaseDescribe_15' name='txtPleaseDescribe_15' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>29. Do you find yourself spending time searching for alcohol and/or drugs, or trying to recover from its effects?</span>
                    <input type='radio' id='rbRecoverFromeffects_Yes' name='rbRecoverFromeffects' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbRecoverFromeffects_No' name='rbRecoverFromeffects' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please Describe:</span>
                    <textarea id='txtPleaseDescribe_16' name='txtPleaseDescribe_16' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>30. Do you feel that you will either relapse or continue to use without treatment or additional support?</span>
                    <input type='radio' id='rbAdditionalSupport_Yes' name='rbAdditionalSupport' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbAdditionalSupport_No' name='rbAdditionalSupport' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe:</span>
                    <textarea id='txtPleaseDescribe_17' name='txtPleaseDescribe_17' className='add-only'></textarea>
                </p>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>31. Are you aware of your triggers to use alcohol and/or drugs?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbAwareYourTriggers_Yes' name='rbAwareYourTriggers' className='add-only' value='Yes' /> Yes &nbsp;
                            <input type='radio' id='rbAwareYourTriggers_No' name='rbAwareYourTriggers' className='add-only' value='No' /> No
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='small'>Please check off any triggers that may apply:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbStrongCravings' name='cbStrongCravings' className='add-only' value='1' />
                            Strong Cravings
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbWorkPressure' name='cbWorkPressure' className='add-only' value='1' />
                            Work Pressure
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMentalsHealth' name='cbMentalHealth' className='add-only' value='1' />
                            Mental Health
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbRelationshipProblems' name='cbRelationshipProblems' className='add-only' value='1' />
                            Relationship Problems
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='CBDealing' name='CBDealing' className='add-only' value='1' />
                            Difficulty Dealing with Feelings
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFinancialStressors' name='cbFinancialStressors' className='add-only' value='1' />
                            Financial Stressors
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPhysicalHealths' name='cbPhysicalHealths' className='add-only' value='1' />
                            Physical Health
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSchoolPressure' name='cbSchoolPressure' className='add-only' value='1' />
                            School Pressure
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEnvironment' name='cbEnvironment' className='add-only' value='1' />
                            cbEnvironment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbUnemployment' name='cbUnemployment' className='add-only' value='1' />
                            Unemployment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbChronicPain' name='cbChronicPain' className='add-only' value='1' />
                            ChronicPain
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPeerPressure' name='cbPeerPressure' className='add-only' value='1' />
                            Peer Pressure
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbAware_Other' name='cbAware_Other' className='add-only' value='1' />
                            Other: &nbsp;
                            <input type='text' id='txtAware_Other' name='txtAware_Other' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>32. What do you do if you are triggered?</span>
                    <textarea id='txtTriggered' name='txtTriggered' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>33. Can you please describe any attempts you have made to either control or cut down on your alcohol and/or drug use?</span>
                    <textarea id='txtDescribeAnyAttempt' name='txtDescribeAnyAttempt' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>34. What is the longest period of time that you have gone without using alcohol and/or drugs?</span>
                    <textarea id='txtLongestPeriod' name='txtLongestPeriod' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>35. What helped and didn't help?</span>
                    <textarea id='txtHelped' name='txtHelped' className='add-only'></textarea>
                </p>

                <p className='w-750'><h3>Please circle one of the following levels of severity</h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Severity Rating- Dimension 5 (Relapse, continued Use, or Continued Problem Potential)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>0 &nbsp;
                            <input type='radio' id='rb_None_5' name='rbSeverityRating_5' className='add-only' value='None' /> None
                        </td>
                        <td className='w-150'>1 &nbsp;
                            <input type='radio' id='rb_Mild_5' name='rbSeverityRating_5' className='add-only' value='Mild' /> Mild
                        </td>
                        <td className='w-150'>2 &nbsp;
                            <input type='radio' id='rb_Moderate_5' name='rbSeverityRating_5' className='add-only' value='Moderate' /> Moderate
                        </td>
                        <td className='w-150'>3 &nbsp;
                            <input type='radio' id='rb_Severe_5' name='rbSeverityRating_5' className='add-only' value='Severe' /> Severe
                        </td>
                        <td className='w-150'>4 &nbsp;
                            <input type='radio' id='rb_VerySevere_5' name='rbSeverityRating_5' className='add-only' value='VerySevere' /> Very Severe
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='small'>Low/no potential for relapse. Good ability to cope.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Minimal relapse potential. Some risk, but fair coping and relapse prevention skills.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Impaired recognition of risk for relapse. Able to self-manage with prompting.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Little recognition of risk for relapse, poor skills to cope with relapse.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>No coping skills for relapse/ addiction problems. Substance use/behavior, places self/other in imminent danger.</span>
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments</span>
                    <textarea id='txtAdditionalComments_2' name='txtAdditionalComments_2' className='add-only'></textarea>
                </p>
                <p className='w-750'><h2>Dimension 6: Recovery/Living Environment</h2></p>
                <p className='w-750'>
                    <span className='eleHeader'>36. Do you have any relationships that are supportive of your recovery? (e.g., family, friends)</span>
                    <textarea id='txtRelationship' name='txtRelationship' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>37. What is your current living situation (e.g., homeless, living with family/alone)?</span>
                    <textarea id='txtCurrentLivingSituation' name='txtCurrentLivingSituation' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>38. Do you currently live in an environment where others are using drugs?</span>
                    <input type='radio' id='rbEnvironment_Yes' name='rbEnvironment' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbEnvironment_No' name='rbEnvironment' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe:</span>
                    <textarea id='txtPleaseDescribe_18' name='txtPleaseDescribe_18' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>39. Are you currently involved in relationships or situations that pose a threat to your safety?</span>
                    <input type='radio' id='rbSituations_Yes' name='rbSituations' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbSituations_No' name='rbSituations' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe:</span>
                    <textarea id='txtPleaseDescribe_19' name='txtPleaseDescribe_19' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>40. Are you currently involved in relationships or situations that would negatively impact your recovery?</span>
                    <input type='radio' id='rbNegativelyImpact_Yes' name='rbNegativelyImpact' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbNegativelyImpact_No' name='rbNegativelyImpact' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe:</span>
                    <textarea id='txtPleaseDescribe_20' name='txtPleaseDescribe_20' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>41. Are you currently employed or enrolled in school?</span>
                    <input type='radio' id='rbEnrolled_Yes' name='rbEnrolled' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbEnrolled_No' name='rbEnrolled' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe (e.g., where employed, duration of employment, name and type of school):</span>
                    <textarea id='txtPleaseDescribe_21' name='txtPleaseDescribe_21' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>42. Are you currently involved with social services or the legal system (e.g., DCFS, court mandated, probation, parole)?</span>
                    <input type='radio' id='rbSocialServices_Yes' name='rbSocialServices' className='add-only' value='Yes' /> Yes &nbsp;
                    <input type='radio' id='rbSocialServices_No' name='rbSocialServices' className='add-only' value='No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe:</span>
                    <textarea id='txtPleaseDescribe_22' name='txtPleaseDescribe_22' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>If on parole/probation:</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Name of Probation/Parole Officer</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Contact Information</span>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtnameProbationOfficer_1' name='txtnameProbationOfficer_1' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtProbation_Contact_1' name='txtProbation_Contact_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtnameProbationOfficer_2' name='txtnameProbationOfficer_2' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type='text' id='txtProbation_Contact_2' name='txtProbation_Contact_2' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h3>Please circle one of the following levels of severity</h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Severity Rating- Dimension 6 Recovery/Living Environment</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>0 &nbsp;
                            <input type='radio' id='rb_None_6' name='rbSeverityRating_6' className='add-only' value='None' /> None
                        </td>
                        <td className='w-150'>1 &nbsp;
                            <input type='radio' id='rb_Mild_6' name='rbSeverityRating_6' className='add-only' value='Mild' /> Mild
                        </td>
                        <td className='w-150'>2 &nbsp;
                            <input type='radio' id='rb_Moderate_6' name='rbSeverityRating_6' className='add-only' value='Moderate' /> Moderate
                        </td>
                        <td className='w-150'>3 &nbsp;
                            <input type='radio' id='rb_Severe_6' name='rbSeverityRating_6' className='add-only' value='Severe' /> Severe
                        </td>
                        <td className='w-150'>4 &nbsp;
                            <input type='radio' id='rb_VerySevere_6' name='rbSeverityRating_6' className='add-only' value='VerySevere' /> Very Severe
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <span className='small'>Able to cope in environment/ supportive.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Passive/disinterested social support, but still able to cope.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Unsupportive environment, but able to cope with clinical structure most of the time.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Unsupportive environment, difficulty coping even with clinical structure.</span>
                        </td>
                        <td className='w-150'>
                            <span className='small'>Environment toxic/hostile to recovery. Unable to cope and the environment may pose a threat to safety.</span>
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Additional Comments</span>
                    <textarea id='txtAdditionalComments_3' name='txtAdditionalComments_3' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Summary of Multidimensional Assessment</h2></p>

                <p className='w-750'>
                    <ul>
                        <li><b>Dimension 1:</b> Substance Use, Acute Intoxication and/or Withdrawal Potential</li>
                        <li><b>Dimension 2:</b> Biomedical Condition and Complications </li>
                        <li><b>Dimension 3:</b> Emotional, Behavioral, or Cognitive Condition and Complications</li>
                        <li><b>Dimension 4:</b> Readiness to Change</li>
                        <li><b>Dimension 5:</b> Relapse, Continued Use, or Continued Problem Potential</li>
                        <li><b>Dimension 6:</b> Recovery/Living Environment</li>
                    </ul>
                </p>

                <table>
                    <tr>
                        <td className='w-100'>
                            <span className='eleHeader'>Dimension</span>
                        </td>
                        <td className='w-400'>
                            <span className='eleHeader'>Severity Rating (Based on Ratings Above)</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Rationale</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <b>Dimension 1</b>
                        </td>
                        <td className='w-400'>
                            <input type='radio' id='rbNone_1' name='rbDimension1' className='add-only' value='None' /> &nbsp;
                            0 None &nbsp;
                            <input type='radio' id='rbMild_1' name='rbDimension1' className='add-only' value='Mild' /> &nbsp;
                            1 Mild &nbsp;
                            <input type='radio' id='rbModerate_1' name='rbDimension1' className='add-only' value='Moderate' /> &nbsp;
                            2 Moderate &nbsp;
                            <input type='radio' id='rbSevere_1' name='rbDimension1' className='add-only' value='Severe' /> &nbsp;
                            3-4 Severe
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRationale_1' name='txtRationale_1' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <b>Dimension 2</b>
                        </td>
                        <td className='w-400'>
                            <input type='radio' id='rbNone_2' name='rbDimension2' className='add-only' value='None' /> &nbsp;
                            0 None &nbsp;
                            <input type='radio' id='rbMild_2' name='rbDimension2' className='add-only' value='Mild' /> &nbsp;
                            1 Mild &nbsp;
                            <input type='radio' id='rbModerate_2' name='rbDimension2' className='add-only' value='Moderate' /> &nbsp;
                            2 Moderate &nbsp;
                            <input type='radio' id='rbSevere_2' name='rbDimension2' className='add-only' value='Severe' /> &nbsp;
                            3-4 Severe
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRationale_2' name='txtRationale_2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <b>Dimension 3</b>
                        </td>
                        <td className='w-400'>
                            <input type='radio' id='rbNone_3' name='rbDimension3' className='add-only' value='None' /> &nbsp;
                            0 None &nbsp;
                            <input type='radio' id='rbMild_3' name='rbDimension3' className='add-only' value='Mild' /> &nbsp;
                            1 Mild &nbsp;
                            <input type='radio' id='rbModerate_3' name='rbDimension3' className='add-only' value='Moderate' /> &nbsp;
                            2 Moderate &nbsp;
                            <input type='radio' id='rbSevere_3' name='rbDimension3' className='add-only' value='Severe' /> &nbsp;
                            3-4 Severe
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRationale_3' name='txtRationale_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <b>Dimension 4</b>
                        </td>
                        <td className='w-400'>
                            <input type='radio' id='rbNone_4' name='rbDimension4' className='add-only' value='None' /> &nbsp;
                            0 None &nbsp;
                            <input type='radio' id='rbMild_4' name='rbDimension4' className='add-only' value='Mild' /> &nbsp;
                            1 Mild &nbsp;
                            <input type='radio' id='rbModerate_4' name='rbDimension4' className='add-only' value='Moderate' /> &nbsp;
                            2 Moderate &nbsp;
                            <input type='radio' id='rbSevere_4' name='rbDimension4' className='add-only' value='Severe' /> &nbsp;
                            3-4 Severe
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRationale_4' name='txtRationale_4' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <b>Dimension 5</b>
                        </td>
                        <td className='w-400'>
                            <input type='radio' id='rbNone_5' name='rbDimension5' className='add-only' value='None' /> &nbsp;
                            0 None &nbsp;
                            <input type='radio' id='rbMild_5' name='rbDimension5' className='add-only' value='Mild' /> &nbsp;
                            1 Mild &nbsp;
                            <input type='radio' id='rbModerate_5' name='rbDimension5' className='add-only' value='Moderate' /> &nbsp;
                            2 Moderate &nbsp;
                            <input type='radio' id='rbSevere_5' name='rbDimension5' className='add-only' value='Severe' /> &nbsp;
                            3-4 Severe
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRationale_5' name='txtRationale_5' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>
                            <b>Dimension 6</b>
                        </td>
                        <td className='w-400'>
                            <input type='radio' id='rbNone_6' name='rbDimension6' className='add-only' value='None' /> &nbsp;
                            0 None &nbsp;
                            <input type='radio' id='rbMild_6' name='rbDimension6' className='add-only' value='Mild' /> &nbsp;
                            1 Mild &nbsp;
                            <input type='radio' id='rbModerate_6' name='rbDimension6' className='add-only' value='Moderate' /> &nbsp;
                            2 Moderate &nbsp;
                            <input type='radio' id='rbSevere_6' name='rbDimension6' className='add-only' value='Severe' /> &nbsp;
                            3-4 Severe
                        </td>
                        <td className='w-250'>
                            <input type='text' id='txtRationale_6' name='txtRationale_6' className='add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h2>Diagnosis: Diagnostic Statistical Manual, 5th Edition (DSM-5) Criteria For Substance Use Disorder</h2></p>
                <p className='w-750'>Please check off any symptoms that have occurred in the past 12 months.</p>


                <table>
                    <tr>
                        <td className='w-360'>
                            <span className='eleHeader'>Substance Use Disorder Criteria (DSM-5)</span>
                        </td>
                        <td className='w-360'>
                            <span className='eleHeader'>Name of Substance(s)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-360'>&nbsp;</td>
                        <td className='w-120'>#1:
                            <input type='text' id='txtNameOfSubstance_1' name='txtNameOfSubstance_1' className='add-only' />
                        </td>
                        <td className='w-120'>#2:
                            <input type='text' id='txtNameOfSubstance_2' name='txtNameOfSubstance_2' className='add-only' />
                        </td>
                        <td className='w-120'>#3:
                            <input type='text' id='txtNameOfSubstance_3' name='txtNameOfSubstance_3' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-360'>1. Substance often taken in larger amounts or over a longer period than was intended.
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_1_1' name='cbSubstance_1_1' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_2_1' name='cbSubstance_2_1' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_3_1' name='cbSubstance_3_1' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-360'>2. There is a persistent desire or unsuccessful efforts to cut down or control substance use.
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_1_2' name='cbSubstance_1_2' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_2_2' name='cbSubstance_2_2' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_3_2' name='cbSubstance_3_2' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-360'>3. A great deal of time is spent in activities necessary to obtain the substance, use the substance, or recover from its effects.
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_1_3' name='cbSubstance_1_3' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_2_3' name='cbSubstance_2_3' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_3_3' name='cbSubstance_3_3' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-360'>4. Craving, or a strong desire or urge to use the substance.
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_1_4' name='cbSubstance_1_4' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_2_4' name='cbSubstance_2_4' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_3_4' name='cbSubstance_3_4' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-360'>5. Recurrent substance use resulting in a failure to fulfill major role obligations at work, school, or home.
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_1_5' name='cbSubstance_1_5' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_2_5' name='cbSubstance_2_5' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_3_5' name='cbSubstance_3_5' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-360'>6. Continued substance use despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects of the substance.
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_1_6' name='cbSubstance_1_6' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_2_6' name='cbSubstance_2_6' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_3_6' name='cbSubstance_3_6' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-360'>7. Important social, occupational, or recreational activities are given up or reduced because of substance use.
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_1_7' name='cbSubstance_1_7' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_2_7' name='cbSubstance_2_7' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_3_7' name='cbSubstance_3_7' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-360'>8. Recurrent substance use in situations in which it is physically hazardous.
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_1_8' name='cbSubstance_1_8' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_2_8' name='cbSubstance_2_8' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_3_8' name='cbSubstance_3_8' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-360'>9. Continued substance use despite knowledge of having a persistent or recurrent physical or psychological problem that is likely to have been caused or exacerbated by the substance.
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_1_9' name='cbSubstance_1_9' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_2_9' name='cbSubstance_2_9' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_3_9' name='cbSubstance_3_9' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-360'>10. Tolerance, as defined by either of the following:<br />
                            -A need for markedly increased amounts of the substance toachieve intoxication or desired effect.<br />
                            -A markedly diminished effect with continued use of the sameamount of the substance.
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_1_10' name='cbSubstance_1_10' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_2_10' name='cbSubstance_2_10' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_3_10' name='cbSubstance_3_10' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-360'>11. Withdrawal, as manifested by either of the following:<br />
                            -The characteristic withdrawal syndrome for the substance.<br />
                            -Substance (or a closely related substance) is taken to relieve oravoid withdrawal symptoms.
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_1_11' name='cbSubstance_1_11' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_2_11' name='cbSubstance_2_11' className='add-only' value='1' /></center>
                        </td>
                        <td className='w-120'>
                            <center><input type='checkbox' id='cbSubstance_3_11' name='cbSubstance_3_11' className='add-only' value='1' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>
                    <tr>
                        <td className='w-360'>
                            <b>Total Number of Criteria</b>
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTotalNumberOfCriteria_1' name='txtTotalNumberOfCriteria_1' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTotalNumberOfCriteria_2' name='txtTotalNumberOfCriteria_2' className='add-only' />
                        </td>
                        <td className='w-120'>
                            <input type='text' id='txtTotalNumberOfCriteria_3' name='txtTotalNumberOfCriteria_3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>List of Substance Use Disorder(s) that Meet DSM-5 Criteria and Date of DSM-5 Diagnosis (specify severity level):</span>
                    <textarea id='txtListSubstanceUseDisorder' name='txtListSubstanceUseDisorder' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    *The presence of at least 2 of these criteria indicates a substance use disorder.
                </p>
                <p className='w-750'>
                    ** The severity of the substance use disorder is defined as:
                </p>
                <ul>
                    <li><b>Mild:</b>
                        Presence of 2-3 criteria</li>
                    <li>
                        <b>Moderate:</b>
                        Presence of 4-5 criteria
                    </li>
                    <li>
                        <b>Severe:</b>
                        Presence of 6 or more criteria
                    </li>
                </ul>

                <p className='w-750'><h2>ASAM Level Of Care Determination Tool</h2></p>

                <p className='w-750'>
                    Instructions: For each dimension, indicate the least intensive level of care that is appropriate based on the patient's severity/functioning and service needs.
                </p>
                <p className='w-750'><h3>Legend</h3></p>
                <ul>
                    <li><b>Dimension 1:</b> Substance Use, Acute Intoxication and/or Withdrawal Potential</li>
                    <li><b>Dimension 2:</b> Biomedical Condition and Complications</li>
                    <li><b>Dimension 3:</b> Emotional, Behavioral, or Cognitive Condition and Complications</li>
                    <li><b>Dimension 4:</b> Readiness to Change</li>
                    <li><b>Dimension 5:</b> Relapse, Continued Use, or Continued Problem Potential</li>
                    <li><b>Dimension 6:</b> Recovery/Living Environment</li>
                </ul>

                <table>
                    <tr>
                        <td className='w-270'>
                            <span className='eleHeader'>ASAM Criteria Level of Care-Withdrawal Management</span>
                        </td>
                        <td className='w-60'>
                            <span className='eleHeader'>ASAM Level</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 1</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 2</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 3</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'><b>Severity / Impairment Rating</b></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>Ambulatory Withdrawal Management without Extended On-Site Monitoring</td>
                        <td className='w-60'>1-WM</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim1_None' name='rbAsam1_Dim1' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim1_Mild' name='rbAsam1_Dim1' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim1_Mod' name='rbAsam1_Dim1' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim1_Sev' name='rbAsam1_Dim1' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim2_None' name='rbAsam1_Dim2' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim2_Mild' name='rbAsam1_Dim2' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim2_Mod' name='rbAsam1_Dim2' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim2_Sev' name='rbAsam1_Dim2' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim3_None' name='rbAsam1_Dim3' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim3_Mild' name='rbAsam1_Dim3' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim3_Mod' name='rbAsam1_Dim3' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim3_Sev' name='rbAsam1_Dim3' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 4</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 5</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 6</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim4_None' name='rbAsam1_Dim4' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim4_Mild' name='rbAsam1_Dim4' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim4_Mod' name='rbAsam1_Dim4' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim4_Sev' name='rbAsam1_Dim4' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim5_None' name='rbAsam1_Dim5' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim5_Mild' name='rbAsam1_Dim5' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim5_Mod' name='rbAsam1_Dim5' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim5_Sev' name='rbAsam1_Dim5' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim6_None' name='rbAsam1_Dim6' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim6_Mild' name='rbAsam1_Dim6' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim6_Mod' name='rbAsam1_Dim6' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam1_Dim6_Sev' name='rbAsam1_Dim6' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 1</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 2</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 3</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>Ambulatory Withdrawal Management with Extended On-Site Monitoring</td>
                        <td className='w-60'>2-WM</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim1_None' name='rbAsam2_Dim1' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim1_Mild' name='rbAsam2_Dim1' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim1_Mod' name='rbAsam2_Dim1' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim1_Sev' name='rbAsam2_Dim1' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim2_None' name='rbAsam2_Dim2' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim2_Mild' name='rbAsam2_Dim2' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim2_Mod' name='rbAsam2_Dim2' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim2_Sev' name='rbAsam2_Dim2' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim3_None' name='rbAsam2_Dim3' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim3_Mild' name='rbAsam2_Dim3' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim3_Mod' name='rbAsam2_Dim3' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim3_Sev' name='rbAsam2_Dim3' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 4</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 5</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 6</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim4_None' name='rbAsam2_Dim4' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim4_Mild' name='rbAsam2_Dim4' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim4_Mod' name='rbAsam2_Dim4' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim4_Sev' name='rbAsam2_Dim4' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim5_None' name='rbAsam2_Dim5' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim5_Mild' name='rbAsam2_Dim5' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim5_Mod' name='rbAsam2_Dim5' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim5_Sev' name='rbAsam2_Dim5' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim6_None' name='rbAsam2_Dim6' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim6_Mild' name='rbAsam2_Dim6' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim6_Mod' name='rbAsam2_Dim6' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam2_Dim6_Sev' name='rbAsam2_Dim6' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 1</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 2</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 3</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>Clinically Managed Residential Withdrawal Management</td>
                        <td className='w-60'>3.2-WM</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim1_None' name='rbAsam3_Dim1' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim1_Mild' name='rbAsam3_Dim1' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim1_Mod' name='rbAsam3_Dim1' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim1_Sev' name='rbAsam3_Dim1' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim2_None' name='rbAsam3_Dim2' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim2_Mild' name='rbAsam3_Dim2' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim2_Mod' name='rbAsam3_Dim2' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim2_Sev' name='rbAsam3_Dim2' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim3_None' name='rbAsam3_Dim3' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim3_Mild' name='rbAsam3_Dim3' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim3_Mod' name='rbAsam3_Dim3' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim3_Sev' name='rbAsam3_Dim3' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 4</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 5</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 6</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim4_None' name='rbAsam3_Dim4' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim4_Mild' name='rbAsam3_Dim4' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim4_Mod' name='rbAsam3_Dim4' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim4_Sev' name='rbAsam3_Dim4' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim5_None' name='rbAsam3_Dim5' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim5_Mild' name='rbAsam3_Dim5' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim5_Mod' name='rbAsam3_Dim5' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim5_Sev' name='rbAsam3_Dim5' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim6_None' name='rbAsam3_Dim6' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim6_Mild' name='rbAsam3_Dim6' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim6_Mod' name='rbAsam3_Dim6' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam3_Dim6_Sev' name='rbAsam3_Dim6' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 1</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 2</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 3</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>Medically Monitored Inpatient Withdrawal Management</td>
                        <td className='w-60'>3.7-WM</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim1_None' name='rbAsam4_Dim1' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim1_Mild' name='rbAsam4_Dim1' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim1_Mod' name='rbAsam4_Dim1' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim1_Sev' name='rbAsam4_Dim1' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim2_None' name='rbAsam4_Dim2' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim2_Mild' name='rbAsam4_Dim2' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim2_Mod' name='rbAsam4_Dim2' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim2_Sev' name='rbAsam4_Dim2' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim3_None' name='rbAsam4_Dim3' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim3_Mild' name='rbAsam4_Dim3' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim3_Mod' name='rbAsam4_Dim3' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim3_Sev' name='rbAsam4_Dim3' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 4</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 5</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 6</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim4_None' name='rbAsam4_Dim4' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim4_Mild' name='rbAsam4_Dim4' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim4_Mod' name='rbAsam4_Dim4' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim4_Sev' name='rbAsam4_Dim4' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim5_None' name='rbAsam4_Dim5' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim5_Mild' name='rbAsam4_Dim5' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim5_Mod' name='rbAsam4_Dim5' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim5_Sev' name='rbAsam4_Dim5' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim6_None' name='rbAsam4_Dim6' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim6_Mild' name='rbAsam4_Dim6' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim6_Mod' name='rbAsam4_Dim6' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam4_Dim6_Sev' name='rbAsam4_Dim6' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 1</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 2</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 3</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>Medically Managed Intensive Inpatient Withdrawal Management</td>
                        <td className='w-60'>4-WM</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim1_None' name='rbAsam5_Dim1' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim1_Mild' name='rbAsam5_Dim1' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim1_Mod' name='rbAsam5_Dim1' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim1_Sev' name='rbAsam5_Dim1' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim2_None' name='rbAsam5_Dim2' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim2_Mild' name='rbAsam5_Dim2' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim2_Mod' name='rbAsam5_Dim2' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim2_Sev' name='rbAsam5_Dim2' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim3_None' name='rbAsam5_Dim3' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim3_Mild' name='rbAsam5_Dim3' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim3_Mod' name='rbAsam5_Dim3' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim3_Sev' name='rbAsam5_Dim3' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 4</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 5</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 6</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim4_None' name='rbAsam5_Dim4' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim4_Mild' name='rbAsam5_Dim4' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim4_Mod' name='rbAsam5_Dim4' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim4_Sev' name='rbAsam5_Dim4' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim5_None' name='rbAsam5_Dim5' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim5_Mild' name='rbAsam5_Dim5' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim5_Mod' name='rbAsam5_Dim5' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim5_Sev' name='rbAsam5_Dim5' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim6_None' name='rbAsam5_Dim6' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim6_Mild' name='rbAsam5_Dim6' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim6_Mod' name='rbAsam5_Dim6' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam5_Dim6_Sev' name='rbAsam5_Dim6' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <b>ASAM Criteria Level of Care- Other Treatment and Recovery Services</b>
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 1</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 2</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 3</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>Early Intervention</td>
                        <td className='w-60'>0.5</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim1_None' name='rbAsam6_Dim1' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim1_Mild' name='rbAsam6_Dim1' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim1_Mod' name='rbAsam6_Dim1' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim1_Sev' name='rbAsam6_Dim1' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim2_None' name='rbAsam6_Dim2' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim2_Mild' name='rbAsam6_Dim2' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim2_Mod' name='rbAsam6_Dim2' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim2_Sev' name='rbAsam6_Dim2' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim3_None' name='rbAsam6_Dim3' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim3_Mild' name='rbAsam6_Dim3' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim3_Mod' name='rbAsam6_Dim3' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim3_Sev' name='rbAsam6_Dim3' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 4</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 5</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 6</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim4_None' name='rbAsam6_Dim4' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim4_Mild' name='rbAsam6_Dim4' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim4_Mod' name='rbAsam6_Dim4' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim4_Sev' name='rbAsam6_Dim4' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim5_None' name='rbAsam6_Dim5' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim5_Mild' name='rbAsam6_Dim5' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim5_Mod' name='rbAsam6_Dim5' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim5_Sev' name='rbAsam6_Dim5' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim6_None' name='rbAsam6_Dim6' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim6_Mild' name='rbAsam6_Dim6' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim6_Mod' name='rbAsam6_Dim6' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam6_Dim6_Sev' name='rbAsam6_Dim6' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 1</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 2</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 3</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>Outpatient Services</td>
                        <td className='w-60'>1</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim1_None' name='rbAsam7_Dim1' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim1_Mild' name='rbAsam7_Dim1' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim1_Mod' name='rbAsam7_Dim1' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim1_Sev' name='rbAsam7_Dim1' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim2_None' name='rbAsam7_Dim2' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim2_Mild' name='rbAsam7_Dim2' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim2_Mod' name='rbAsam7_Dim2' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim2_Sev' name='rbAsam7_Dim2' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim3_None' name='rbAsam7_Dim3' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim3_Mild' name='rbAsam7_Dim3' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim3_Mod' name='rbAsam7_Dim3' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim3_Sev' name='rbAsam7_Dim3' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 4</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 5</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 6</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim4_None' name='rbAsam7_Dim4' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim4_Mild' name='rbAsam7_Dim4' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim4_Mod' name='rbAsam7_Dim4' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim4_Sev' name='rbAsam7_Dim4' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim5_None' name='rbAsam7_Dim5' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim5_Mild' name='rbAsam7_Dim5' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim5_Mod' name='rbAsam7_Dim5' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim5_Sev' name='rbAsam7_Dim5' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim6_None' name='rbAsam7_Dim6' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim6_Mild' name='rbAsam7_Dim6' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim6_Mod' name='rbAsam7_Dim6' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam7_Dim6_Sev' name='rbAsam7_Dim6' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 1</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 2</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 3</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>Intensive Outpatient Services</td>
                        <td className='w-60'>2.1</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim1_None' name='rbAsam8_Dim1' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim1_Mild' name='rbAsam8_Dim1' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim1_Mod' name='rbAsam8_Dim1' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim1_Sev' name='rbAsam8_Dim1' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim2_None' name='rbAsam8_Dim2' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim2_Mild' name='rbAsam8_Dim2' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim2_Mod' name='rbAsam8_Dim2' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim2_Sev' name='rbAsam8_Dim2' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim3_None' name='rbAsam8_Dim3' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim3_Mild' name='rbAsam8_Dim3' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim3_Mod' name='rbAsam8_Dim3' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim3_Sev' name='rbAsam8_Dim3' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 4</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 5</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 6</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim4_None' name='rbAsam8_Dim4' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim4_Mild' name='rbAsam8_Dim4' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim4_Mod' name='rbAsam8_Dim4' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim4_Sev' name='rbAsam8_Dim4' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim5_None' name='rbAsam8_Dim5' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim5_Mild' name='rbAsam8_Dim5' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim5_Mod' name='rbAsam8_Dim5' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim5_Sev' name='rbAsam8_Dim5' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim6_None' name='rbAsam8_Dim6' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim6_Mild' name='rbAsam8_Dim6' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim6_Mod' name='rbAsam8_Dim6' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam8_Dim6_Sev' name='rbAsam8_Dim6' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 1</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 2</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 3</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>Partial Hospitalization Services</td>
                        <td className='w-60'>2.5</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim1_None' name='rbAsam9_Dim1' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim1_Mild' name='rbAsam9_Dim1' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim1_Mod' name='rbAsam9_Dim1' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim1_Sev' name='rbAsam9_Dim1' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim2_None' name='rbAsam9_Dim2' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim2_Mild' name='rbAsam9_Dim2' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim2_Mod' name='rbAsam9_Dim2' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim2_Sev' name='rbAsam9_Dim2' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim3_None' name='rbAsam9_Dim3' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim3_Mild' name='rbAsam9_Dim3' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim3_Mod' name='rbAsam9_Dim3' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim3_Sev' name='rbAsam9_Dim3' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 4</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 5</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 6</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim4_None' name='rbAsam9_Dim4' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim4_Mild' name='rbAsam9_Dim4' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim4_Mod' name='rbAsam9_Dim4' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim4_Sev' name='rbAsam9_Dim4' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim5_None' name='rbAsam9_Dim5' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim5_Mild' name='rbAsam9_Dim5' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim5_Mod' name='rbAsam9_Dim5' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim5_Sev' name='rbAsam9_Dim5' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim6_None' name='rbAsam9_Dim6' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim6_Mild' name='rbAsam9_Dim6' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim6_Mod' name='rbAsam9_Dim6' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam9_Dim6_Sev' name='rbAsam9_Dim6' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 1</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 2</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 3</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>Clinically Managed Low-Intensity Residential Services</td>
                        <td className='w-60'>3.1</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim1_None' name='rbAsam10_Dim1' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim1_Mild' name='rbAsam10_Dim1' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim1_Mod' name='rbAsam10_Dim1' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim1_Sev' name='rbAsam10_Dim1' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim2_None' name='rbAsam10_Dim2' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim2_Mild' name='rbAsam10_Dim2' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim2_Mod' name='rbAsam10_Dim2' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim2_Sev' name='rbAsam10_Dim2' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim3_None' name='rbAsam10_Dim3' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim3_Mild' name='rbAsam10_Dim3' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim3_Mod' name='rbAsam10_Dim3' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim3_Sev' name='rbAsam10_Dim3' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 4</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 5</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 6</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim4_None' name='rbAsam10_Dim4' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim4_Mild' name='rbAsam10_Dim4' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim4_Mod' name='rbAsam10_Dim4' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim4_Sev' name='rbAsam10_Dim4' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim5_None' name='rbAsam10_Dim5' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim5_Mild' name='rbAsam10_Dim5' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim5_Mod' name='rbAsam10_Dim5' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim5_Sev' name='rbAsam10_Dim5' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim6_None' name='rbAsam10_Dim6' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim6_Mild' name='rbAsam10_Dim6' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim6_Mod' name='rbAsam10_Dim6' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam10_Dim6_Sev' name='rbAsam10_Dim6' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 1</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 2</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 3</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>Clinically Managed Population-Specific High-Intensity Residential Services</td>
                        <td className='w-60'>3.3</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim1_None' name='rbAsam11_Dim1' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim1_Mild' name='rbAsam11_Dim1' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim1_Mod' name='rbAsam11_Dim1' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim1_Sev' name='rbAsam11_Dim1' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim2_None' name='rbAsam11_Dim2' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim2_Mild' name='rbAsam11_Dim2' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim2_Mod' name='rbAsam11_Dim2' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim2_Sev' name='rbAsam11_Dim2' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim3_None' name='rbAsam11_Dim3' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim3_Mild' name='rbAsam11_Dim3' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim3_Mod' name='rbAsam11_Dim3' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim3_Sev' name='rbAsam11_Dim3' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 4</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 5</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 6</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim4_None' name='rbAsam11_Dim4' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim4_Mild' name='rbAsam11_Dim4' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim4_Mod' name='rbAsam11_Dim4' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim4_Sev' name='rbAsam11_Dim4' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim5_None' name='rbAsam11_Dim5' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim5_Mild' name='rbAsam11_Dim5' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim5_Mod' name='rbAsam11_Dim5' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim5_Sev' name='rbAsam11_Dim5' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim6_None' name='rbAsam11_Dim6' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim6_Mild' name='rbAsam11_Dim6' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim6_Mod' name='rbAsam11_Dim6' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam11_Dim6_Sev' name='rbAsam11_Dim6' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 1</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 2</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 3</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>Clinically Managed High-Intensity Residential Services</td>
                        <td className='w-60'>3.5</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim1_None' name='rbAsam12_Dim1' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim1_Mild' name='rbAsam12_Dim1' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim1_Mod' name='rbAsam12_Dim1' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim1_Sev' name='rbAsam12_Dim1' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim2_None' name='rbAsam12_Dim2' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim2_Mild' name='rbAsam12_Dim2' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim2_Mod' name='rbAsam12_Dim2' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim2_Sev' name='rbAsam12_Dim2' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim3_None' name='rbAsam12_Dim3' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim3_Mild' name='rbAsam12_Dim3' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim3_Mod' name='rbAsam12_Dim3' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim3_Sev' name='rbAsam12_Dim3' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 4</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 5</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 6</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim4_None' name='rbAsam12_Dim4' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim4_Mild' name='rbAsam12_Dim4' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim4_Mod' name='rbAsam12_Dim4' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim4_Sev' name='rbAsam12_Dim4' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim5_None' name='rbAsam12_Dim5' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim5_Mild' name='rbAsam12_Dim5' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim5_Mod' name='rbAsam12_Dim5' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim5_Sev' name='rbAsam12_Dim5' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim6_None' name='rbAsam12_Dim6' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim6_Mild' name='rbAsam12_Dim6' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim6_Mod' name='rbAsam12_Dim6' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam12_Dim6_Sev' name='rbAsam12_Dim6' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 1</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 2</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 3</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>Medically Monitored Intensive Inpatient Services</td>
                        <td className='w-60'>3.7</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim1_None' name='rbAsam13_Dim1' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim1_Mild' name='rbAsam13_Dim1' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim1_Mod' name='rbAsam13_Dim1' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim1_Sev' name='rbAsam13_Dim1' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim2_None' name='rbAsam13_Dim2' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim2_Mild' name='rbAsam13_Dim2' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim2_Mod' name='rbAsam13_Dim2' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim2_Sev' name='rbAsam13_Dim2' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim3_None' name='rbAsam13_Dim3' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim3_Mild' name='rbAsam13_Dim3' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim3_Mod' name='rbAsam13_Dim3' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim3_Sev' name='rbAsam13_Dim3' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 4</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 5</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 6</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim4_None' name='rbAsam13_Dim4' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim4_Mild' name='rbAsam13_Dim4' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim4_Mod' name='rbAsam13_Dim4' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim4_Sev' name='rbAsam13_Dim4' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim5_None' name='rbAsam13_Dim5' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim5_Mild' name='rbAsam13_Dim5' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim5_Mod' name='rbAsam13_Dim5' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim5_Sev' name='rbAsam13_Dim5' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim6_None' name='rbAsam13_Dim6' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim6_Mild' name='rbAsam13_Dim6' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim6_Mod' name='rbAsam13_Dim6' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam13_Dim6_Sev' name='rbAsam13_Dim6' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 1</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 2</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 3</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>Medically Managed Intensive Inpatient Services</td>
                        <td className='w-60'>4</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim1_None' name='rbAsam14_Dim1' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim1_Mild' name='rbAsam14_Dim1' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim1_Mod' name='rbAsam14_Dim1' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim1_Sev' name='rbAsam14_Dim1' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim2_None' name='rbAsam14_Dim2' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim2_Mild' name='rbAsam14_Dim2' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim2_Mod' name='rbAsam14_Dim2' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim2_Sev' name='rbAsam14_Dim2' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim3_None' name='rbAsam14_Dim3' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim3_Mild' name='rbAsam14_Dim3' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim3_Mod' name='rbAsam14_Dim3' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim3_Sev' name='rbAsam14_Dim3' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 4</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 5</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 6</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim4_None' name='rbAsam14_Dim4' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim4_Mild' name='rbAsam14_Dim4' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim4_Mod' name='rbAsam14_Dim4' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim4_Sev' name='rbAsam14_Dim4' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim5_None' name='rbAsam14_Dim5' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim5_Mild' name='rbAsam14_Dim5' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim5_Mod' name='rbAsam14_Dim5' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim5_Sev' name='rbAsam14_Dim5' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim6_None' name='rbAsam14_Dim6' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim6_Mild' name='rbAsam14_Dim6' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim6_Mod' name='rbAsam14_Dim6' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam14_Dim6_Sev' name='rbAsam14_Dim6' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <b>ASAM Criteria Level of Care- Other Treatment and Recovery Services</b>
                        </td>
                    </tr>
                    
                    <tr>
                        <td className='w-750'><hr /></td>
                    </tr>

                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 1</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 2</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 3</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>Opioid Treatment Program</td>
                        <td className='w-60'>OTP</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim1_None' name='rbAsam15_Dim1' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim1_Mild' name='rbAsam15_Dim1' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim1_Mod' name='rbAsam15_Dim1' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim1_Sev' name='rbAsam15_Dim1' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim2_None' name='rbAsam15_Dim2' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim2_Mild' name='rbAsam15_Dim2' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim2_Mod' name='rbAsam15_Dim2' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim2_Sev' name='rbAsam15_Dim2' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim3_None' name='rbAsam15_Dim3' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim3_Mild' name='rbAsam15_Dim3' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim3_Mod' name='rbAsam15_Dim3' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim3_Sev' name='rbAsam15_Dim3' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 4</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 5</span>
                        </td>
                        <td className='w-140'>
                            <span className='eleHeader'>Dimension 6</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-330'>&nbsp;</td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                        <td className='w-35'><center>None</center></td>
                        <td className='w-35'><center>Mild</center></td>
                        <td className='w-35'><center>Mod</center></td>
                        <td className='w-35'><center>Sev</center></td>
                    </tr>
                    <tr>
                        <td className='w-270'>&nbsp;</td>
                        <td className='w-60'>&nbsp;</td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim4_None' name='rbAsam15_Dim4' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim4_Mild' name='rbAsam15_Dim4' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim4_Mod' name='rbAsam15_Dim4' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim4_Sev' name='rbAsam15_Dim4' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim5_None' name='rbAsam15_Dim5' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim5_Mild' name='rbAsam15_Dim5' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim5_Mod' name='rbAsam15_Dim5' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim5_Sev' name='rbAsam15_Dim5' className='add-only' value='Sev' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim6_None' name='rbAsam15_Dim6' className='add-only' value='None' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim6_Mild' name='rbAsam15_Dim6' className='add-only' value='Mild' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim6_Mod' name='rbAsam15_Dim6' className='add-only' value='Mod' /></center>
                        </td>
                        <td className='w-35'>
                            <center><input type='radio' id='rbAsam15_Dim6_Sev' name='rbAsam15_Dim6' className='add-only' value='Sev' /></center>
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Would the patient with alcohol or opioid use disorders benefit from and be interested in Medication-Assisted Treatment (MAT)?</span>
                    <input type='radio' id='rbMAT_Yes' name='rbMAT' className='add-only' value='Y /es' /> Yes &nbsp;
                    <input type='radio' id='rbMAT_No' name='rbMAT' className='add-only' value=' /No' /> No
                </p>
                <p className='w-750'>
                    <span className='small'>Please describe:</span>
                    <textarea id='txtPleaseDescribe_23' name='txtPleaseDescribe_23' className='add-only'></textarea>
                </p>

                <p className='w-750'><h2>Placement Summary</h2></p>

                <p className='w-750'>
                    <b>Level of Care:</b>
                    Enter the ASAM Level of Care (e.g., 3.1, 2.1, 3.2, W.M) number that offers the most appropriate treatment setting given the patient's current severity and functioning: &nbsp;
                    <input type='text' id='txtLevelOfCare' name='txtLevelOfCare' className='add-only w-150 custom-add-only' />
                </p>

                <p className='w-750'>
                    <b>Level of Care Provided:</b>
                    Enter the ASAM Level of Care (e.g., 3.1, 2.1, 3.2, W.M) number that offers the most appropriate treatment setting given the patient's current severity and functioning: &nbsp;
                    <input type='text' id='txtLevelOfCareProvided' name='txtLevelOfCareProvided' className='add-only w-150 custom-add-only' />
                </p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Reason for Discrepancy</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNotApplicable' name='cbNotApplicable' className='add-only' value='1' />
                            Not Applicable
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbServiceNotAvailable' name='cbServiceNotAvailable' className='add-only' value='1' />
                            Service Not Available
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbProviderJudgment' name='cbProviderJudgment' className='add-only' value='1' />
                            Provider Judgment
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPatientPreference' name='cbPatientPreference' className='add-only' value='1' />
                            Patient Preference
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbTransportation' name='cbTransportation' className='add-only' value='1' />
                            Transportation
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAccessibility' name='cbAccessibility' className='add-only' value='1' />
                            Accessibility
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbFinancial' name='cbFinancial' className='add-only' value='1' />
                            Financial
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPreferredToWait' name='cbPreferredToWait' className='add-only' value='1' />
                            Preferred to Wait
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPhysicalHelth' name='cbPhysicalHelth' className='add-only' value='1' />
                            Physical Health
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEnviroment' name='cbEnviroment' className='add-only' value='1' />
                            Environment
                        </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbMentalHelth' name='cbMentalHelth' className='add-only' value='1' />
                            Mental Health
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbLanguage' name='cbLanguage' className='add-only' value='1' />
                            Language/ Cultural Considerations
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbReason_Other' name='cbReason_Other' className='add-only' value='1' /> Other: &nbsp;
                            <input type='text' id='txtReason_Other' name='txtReason_Other' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Briefly Explain Discrepancy</span>
                    <textarea id='txtExplainDiscrepancy' name='txtExplainDiscrepancy' className='add-only'></textarea>
                </p>

                <p className='w-750'>
                    <span className='eleHeader'>Designated Treatment Location and Provider Name</span>
                    <textarea id='txtDesignatedTreatmentLocation' name='txtDesignatedTreatmentLocation' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-400'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-400'>Counselor Name (if applicable)</td>
                        <td className='small w-200'>Signature</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-400'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-400'>Licensed-eligible LMHP Name (if applicable)</td>
                        <td className='small w-200'>Signature</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-400'>&nbsp;</td>
                        <td className='signature w-200'>&nbsp;</td>
                        <td className='signature w-150'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-400'>Licensed LMHP Name</td>
                        <td className='small w-200'>Signature</td>
                        <td className='small w-150'>Date</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











